function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22,1C10.42,1,1,10.42,1,22C1,33.578,10.42,43,22,43c11.58,0,21-9.422,21-21C43,10.42,33.58,1,22,1z M18.421,8.682 c0.17-0.178,0.404-0.278,0.65-0.278h5.942c0.244,0,0.48,0.101,0.648,0.278c0.17,0.177,0.26,0.416,0.25,0.661l-0.713,16.466 c-0.02,0.481-0.416,0.861-0.898,0.861h-4.518c-0.481,0-0.878-0.38-0.898-0.861L18.172,9.343C18.162,9.098,18.251,8.858,18.421,8.682 z M24.809,34.584c-0.758,0.673-1.703,1.014-2.809,1.014c-1.105,0-2.051-0.342-2.807-1.014c-0.788-0.701-1.188-1.604-1.188-2.684 s0.399-1.982,1.188-2.684c0.756-0.672,1.701-1.014,2.807-1.014c1.106,0,2.051,0.341,2.809,1.014c0.787,0.7,1.186,1.604,1.186,2.684 S25.596,33.884,24.809,34.584z"
});

function SvgIconWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    enableBackground: "new 0 0 44 44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarn);
export default __webpack_public_path__ + "static/media/icon-warn.cf84e05a.svg";
export { ForwardRef as ReactComponent };